/**
 * Expose the Event class.
 */
module.exports = _Event;


function _Event(type) {
	this.type = type;
	this.isTrusted = false;

	// Set a flag indicating this is not a DOM Event object
	this._yaeti = true;
}



//////////////////
// WEBPACK FOOTER
// ./~/yaeti/lib/Event.js
// module id = 1004
// module chunks = 0 1 2 3